import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxComponent, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { SolicitudModificacionService } from '../../../services/formulacion/solicitud-modificacion.service';
import { switchMap } from 'rxjs/operators';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { FusService, GeneralService, ReversionService } from '../../../services/service.index';
import { ElementSchemaRegistry } from '@angular/compiler';

declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-aprobar-solicitud',
  templateUrl: './aprobar-solicitud.component.html',
  styles: []
})
export class AprobarSolicitudComponent implements OnInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxSelectBoxComponent) selectBox: DxSelectBoxComponent
  clicked: boolean = false;
  montoTotal: number = 0;
  fusEdit: any[];
  nro_fus: string = '';
  verDatos: boolean = false;
  jusReversion = false;
  observacion = false;
  rol: number;
  monto_revertido: number = 0;
  monto_fus: number = 0;
  file: File = null;
  maxFileSize = 2097152;
  typeFiles = ['application/pdf'];
  montoFus: number = 0;
  solicitudes: any[];
  fuses: any[];
  segSolicitudes: any[];
  idSolicitud: number;
  idAux: number;
  fusReversion: any;
  popupVisibleEstado: boolean = false;
  popupVisibleSeg: boolean = false;
  popupVisibleDel: boolean = false;
  popupVisibleSolicitud: boolean = false;
  popupVisibleCambiarEstado: boolean = false;
  popupVisibleR: boolean = false;
  popupVisibleMod: boolean = false;
  popupVisibleAnular: boolean = false;
  hasError: any;
  esReversion: boolean = false;
  baseUrl = environment.apiEndpoint;
  baseUrld = environment.apiEndpoint.substring(0, environment.apiEndpoint.length - 4);
  modelSegu: any = { idSolicitud: 0, fus_id: 0, justificacion: '', estado_solicitud: '', estado_solicitud_id: 0, monto_solicitado: 0, tipo_reversion: '', tipo_reversion_id: 0, estado_id: 0, observacion: '', observacion_id: 0, detalle: [] }
  estados: any[] = [{ id: 1, descripcion: 'OBSERVAR FUS' }, { id: 2, descripcion: 'REVERTIR FUS' }];
  tipo_reversion: any[] = [{ id: 1, descripcion: 'REVERSION PARCIAL' }, { id: 2, descripcion: 'REVERSION TOTAL' }];
  estadoCambiar: any[] = [{ id: 1, descripcion: 'APROBAR SOLICITUD' }, { id: 2, descripcion: 'OBSERVAR SOLICITUD' }];
  estadosFilter: any = [];
  estado: number;
  poaTecho: any;
  estado_solicitud: string;
  esNuevaObs: boolean = false;
  dataResourceObs: any[];
  constructor(private route: ActivatedRoute, private _sms: SolicitudModificacionService, private _fs: FusService, private _rs: ReversionService, private _gs: GeneralService) {

    let u = JSON.parse(localStorage.getItem('u'));
    this.rol = u.rol;
    this.resetErrors();
    if (this.rol == 21) {
      this.estado = 11;
    }
    if (this.rol == 22) {
      this.estado = 11;
    }
    if ((this.rol == 23) || (this.rol == 12)|| (this.rol == 15)) {
      this.estado = 12;
    }
    if ((this.rol == 24) || (this.rol == 13)) {
      this.estado = 14;
    }

    this.getEstadosByUsuario();

  }

  ngOnInit() {
  }

  resetErrors() {
    this.hasError = { tipo_reversion: false, estado_solicitud: false, estado_solicitud_id: false, objeto: false, justificacion: false, fus_id: false, tipo_reversion_id: false, estado_id: false, observacion: false };
  }



  getEstadosByUsuario() {
    this._fs.getFusEstadosByUsuario().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.estadosFilter = result.data;
          this.getListSolicitudesEstado(this.estado);
        }
        else { this.estadosFilter = []; }
      },
      (error) => { console.log('Error', error); });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    },
      // {
      //   location: 'before',
      //   widget: 'dxButton',
      //   options: {
      //     icon: 'refresh',
      //     text: 'Actualizar',
      //     onClick: this.refreshDataGrid.bind(this)
      //   }
      //  }
    );
  }

  refreshDataGrid(e) {
    this.getListSolicitudesEstado(e.value);
    this.dataGrid.instance.refresh();
    this.estado = e.value;

  }

  getListSolicitudesEstado(estado_id: number) {
    this._sms.getListSolicitudByEstadoIdA(estado_id).subscribe(
      (response) => {

        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.solicitudes = result.data;          
        }
        else { this.solicitudes = []; }
      },
      (error) => { console.log('Error', error); });
  }




  showModalDelete(id: number) {
    this.idSolicitud = id;
    this.popupVisibleDel = true;
  }

  getEnviarSolicitud(id: number, estado_id: number) {
    //this.getEstadoSolicitud(this.modelSegu.estado_solicitud_id);
    this.modelSegu.idSolicitud = id;
    this.modelSegu.estado_id = estado_id;
    this.modelSegu.observacion = '';
    this.popupVisibleEstado = true;

  }

  getShowModalCambiarEstado(id: number, estado_id: number) {
    this.resetErrors();
    this.esNuevaObs = false;
    this.modelSegu.idSolicitud = id;
    this.modelSegu.estado_id = '';
    this.modelSegu.observacion = '';
    this.popupVisibleCambiarEstado = true;
  }

  deleteSolicitud() {
    this._sms.deleteSolicitud(this.idSolicitud).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleDel = false;
          this.refreshDataGrid(this.estado);
          toastr.success('Operación realizada exitosamente.');
        } else if (result.status == 201) {
          this.popupVisibleDel = false;
          this.refreshDataGrid(this.estado);
          toastr.success('Operación realizada exitosamente.');
        } else {
          toastr.warning('Ocurrió un inconveniente al realizar la operación.');
        }
      },
      error => { console.log('Error', error); });
  }

  getDatosSolicitudDetalle(idSolicitud: number, idFus: number) {
    this._sms.getDatosSolicitudDetalle(idSolicitud, idFus).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.fusEdit = result.data;
          this.modelSegu.detalle = this.fusEdit;
        }
      },
      (error) => { console.log('Error', error); });
  }



  aprobarEstado() {
    if (this.validCambioEstado()) {
      this._sms.putCambiosEstadoSolicitud(this.modelSegu).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.popupVisibleCambiarEstado = false;
            this.getListSolicitudesEstado(this.estado);
            toastr.success('Datos guardados correctamente.');
          }
          else if (result.status == 201) {
            toastr.warning(response.data);
          }
        },
        (error) => { console.log('Error', error); });
    }
    else {
      toastr.warning('Debe Completar el formulario');
    }
  }

  enviarARevision() {
    this._sms.putCambiosEstadoSolicitud(this.modelSegu).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleEstado = false;
          this.getListSolicitudesEstado(this.estado);
          toastr.success('Datos guardados correctamente.');
        }
        else if (result.status == 201) {
          toastr.warning(response.data);
        }
      },
      (error) => { console.log('Error', error); });

  }
  validCambioEstado() {
    let res = true;
    if (this.modelSegu.observacion == '') {
      this.hasError.observacion = true; res = false;
    }
    if (!UtilHelper.validator(this.modelSegu.estado_id, 0)) {
      this.hasError.estado_id = true; res = false;
    }
    if (this.modelSegu.estado_id == 2) {
      if (this.modelSegu.observacion_id == 0) {
        this.hasError.observacion_id = true; res = false;

      }
    }
    return res;
  }




  handleFileInput(files: FileList) {
    this.file = files.item(0);
    if (this.file != null) {
      if (this.file.size > this.maxFileSize) {
        toastr.warning('El tamaño del archivo no debe exceder los 2MB.');
      }
      if (this.typeFiles.indexOf(this.file.type) == -1) {
        toastr.warning('Formato de archivo no válido, los permitidos son PDF.');
      }
    }
  }



  showModalSeg(id: string, fus: string) {
    this.nro_fus = fus;
    this._sms.getSeguimientoBySolicitudId(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.segSolicitudes = result.data;
        }
      },
      (error) => { console.log('Error', error); });
    this.popupVisibleSeg = true;
  }

  getObservacion(e: any) {    
    if (this.modelSegu.estado_id != '') {
      if (this.modelSegu.estado_id == 1) {
        this.modelSegu.observacion = 'NINGUNA';
        this.esNuevaObs = true;
      }
      else {        
        this.getObservacionesLista();
        this.esNuevaObs = false;
        this.modelSegu.observacion = '';
        this.modelSegu.observacion_id = 0;
        this.modelSegu.estado_id = 2;
      }
    }
  }

  getDescribirObservacion(e: any) {
    var esNueva = this.dataResourceObs.filter(o => o.id == e.value).map(o => o.descripcion).toString();
    if (esNueva == 'Otro') {
      this.modelSegu.observacion = '';
      this.esNuevaObs = true;
    }
    else {
      this.esNuevaObs = false;
      this.modelSegu.observacion = esNueva;
    }
  }

  getObservacionesLista() {
    this._gs.getObservaciones('FUS').subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceObs = result.data;
        }
        else { this.dataResourceObs = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getFusReversionesById(data: any) {    
    this.resetErrors();
    this.clicked = false;
    this.idSolicitud = parseInt(data.id);
    this.modelSegu.idSolicitud = this.idSolicitud;
    this._rs.getFusReversionesPorModById(data.fus_id, data.id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {          
          this.monto_fus = result.data.total_fus;
          this.fusReversion = result.data;
          this.fusReversion.justifica_reversion = data.justificacion;
          this.modelSegu.estado_id = 0;
          this.popupVisibleR = true;
        }
      },
      (error) => { console.log('Error', error); });
  }


  getFusModificacionesById(data: any) {
    this.resetErrors();
    this.clicked = false;
    this.idSolicitud = parseInt(data.id);
    this.modelSegu.idSolicitud = this.idSolicitud;
    this._rs.getFusModificacionesById(data.fus_id, data.id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.monto_fus = result.data.total_fus;
          this.fusReversion = result.data;
          this.fusReversion.justifica_reversion = data.justificacion;
          this.modelSegu.estado_id = 0;
          this.popupVisibleMod = true;
        }
      },
      (error) => { console.log('Error', error); });
  }

  saveReversion() {
    this.jusReversion = false;
    this.observacion = false;
    this.clicked = true;
    this.fusReversion.solicitud_id = this.idSolicitud;
    if (this.validRev()) {
      if (this.modelSegu.estado_id == 2) {
        this.aprobarEstado();
        this.getListSolicitudesEstado(this.estado);
        this.popupVisibleR = false;
      }
      else {
        this.clicked = false;
        this._rs.postFusReversion(this.fusReversion).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.aprobarEstado();
              this.getListSolicitudesEstado(this.estado);
              this.popupVisibleR = false;
              this.clicked = true;
            }
            else if (result.status == 201) {
              toastr.warning(result.data);
              this.popupVisibleR = false;
            }

          });
      }
    }
  }


  saveIncremento() {
    this.jusReversion = false;
    this.observacion = false;
    this.fusReversion.solicitud_id = this.idSolicitud;
    this.clicked = true;
    
    if (this.validRev()) {      
      if (this.modelSegu.estado_id == 2) {
        this.aprobarEstado();
        this.popupVisibleMod = false;
      }
      else {
        this._sms.postModificacionFUS(this.fusReversion).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.aprobarEstado();              
              this.popupVisibleMod = false;
              this.clicked = false;
            }

          });
      }
    }
  }

  validRev() {
    let res = true, f1 = false, f2 = false, f3 = false, f4 = false, f5 = false, total: number;
    if (!UtilHelper.validator(this.fusReversion.justifica_reversion, 'text')) {
      f1 = true;;
    }
    if (this.modelSegu.estado_id == 1) {
      this.fusReversion.detalle.forEach(item => {
        if ((item.revertido <= 0))
          f2 = true;
        if (parseFloat(item.revertido) + parseFloat(item.total_revertido) > (parseFloat(item.monto_fus) + parseFloat(item.total_incrementado)))
          f5 = true;
      });
    }
    if (this.modelSegu.observacion == '') {
      this.hasError.observacion = true; f3 = true;
    }
    if (this.modelSegu.estado_id == 0) {
      this.hasError.estado_id = true; f4 = true; res = false;
    }

    if (this.modelSegu.estado_id == 2) {
      if (this.modelSegu.observacion_id == 0) {
        this.hasError.observacion_id = true; res = false;
      }
    }

    if (f1) {
      res = false;
      toastr.warning('Complete la justificación');
    }
    if (f4) {
      res = false;
      toastr.warning('Elija un estado');
    }
    if (f3) {
      res = false;
      toastr.warning('Ingrese una observación');
    }
    if (f5) {
      res = false;
      toastr.warning('El monto solicitado es mayor al monto FUS, revise los montos...');
    }

    return res;
  }


  showModalAnular(id: number) {

    this.resetErrors();
    this.esNuevaObs = false;
    this.modelSegu.idSolicitud = id;
    this.modelSegu.estado_id = 18;
    this.popupVisibleAnular = true;
  }

  anularSolicitud() {
    this._sms.putCambiosEstadoSolicitud(this.modelSegu).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleAnular = false;
          this.getListSolicitudesEstado(this.estado);
          toastr.success('Operación realizada correctamente.');
        }
        else if (result.status == 201) {
          toastr.warning(response.data);
        }
      },
      (error) => { console.log('Error', error); });

  }
}
